module.exports = __webpack_public_path__ + "img/emoji.2fce7160.png";